import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { SectionWrapper } from "@/components/ui/section-wrapper";
import { Button } from "@/components/ui/button";

export function TestimonialsSection() {
  return (
    <SectionWrapper>
      <div className="text-center max-w-2xl mx-auto">
        <div className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-4 py-1.5 text-sm font-medium text-primary mb-6">
          <Sparkles className="h-4 w-4" />
          Early Access
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
          Be among the first to try ProteasAI
        </h2>
        <p className="text-lg text-muted-foreground mb-8">
          Join store owners who are already using AI to optimize their WooCommerce stores. 
          Your feedback helps us build the perfect tool for you.
        </p>
        <Button size="lg" asChild>
          <Link to="/signup">
            Start Free Today
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </div>
    </SectionWrapper>
  );
}
